/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
    SourceContactToJSONTyped,
} from './SourceContact';

/**
 * 
 * @export
 * @interface SourceContactTag
 */
export interface SourceContactTag {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    type: number;
    /**
     * 
     */
    source_contacts?: Array<SourceContact>;
}

/**
 * Check if a given object implements the SourceContactTag interface.
 */
export function instanceOfSourceContactTag(value: object): value is SourceContactTag {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SourceContactTagFromJSON(json: any): SourceContactTag {
    return SourceContactTagFromJSONTyped(json, false);
}

export function SourceContactTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceContactTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'type': json['type'],
        'source_contacts': json['source_contacts'] == null ? undefined : ((json['source_contacts'] as Array<any>).map(SourceContactFromJSON)),
    };
}

export function SourceContactTagToJSON(json: any): SourceContactTag {
    return SourceContactTagToJSONTyped(json, false);
}

export function SourceContactTagToJSONTyped(value?: SourceContactTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'source_contacts': value['source_contacts'] == null ? undefined : ((value['source_contacts'] as Array<any>).map(SourceContactToJSON)),
    };
}

